module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_04-414eb940fc2fb3eb25bb850f0b2e2662.jpg";